import { isIST } from '@casanova/casanova-common/lib/utils/env';
import { validateRolePermissions } from 'utils/roles';

export const getContextualMenuItem = (menuItem, permission) =>
  // PENDING REAL VALIDATION
  isIST() ? (validateRolePermissions(permission) ? menuItem : {}) : menuItem;
